<button [class]="buttonClasses" [ngStyle]="buttonStyles" [type]="type" [disabled]="disabled || loading" (click)="onClick($event)">
    <span class="pill-button__content" *ngIf="!loading">
        <ng-content></ng-content>
    </span>
    <span class="pill-button__loader" *ngIf="loading" aria-label="Cargando"></span>
</button>
